// DAW Constants and Shared Configuration

export const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
export const OCTAVES = [2, 3, 4, 5, 6];
export const ALL_NOTES = OCTAVES.flatMap(oct => NOTE_NAMES.map(note => `${note}${oct}`)).reverse();

// CDN Instrument Library - Comprehensive World Collection
export const INSTRUMENT_LIBRARY = {
  // ============================================
  // KEYS & PIANOS
  // ============================================
  piano: { 
    name: 'Grand Piano', 
    category: 'Keys', 
    region: 'Western',
    color: '#3b82f6', 
    cdnBase: 'https://tonejs.github.io/audio/salamander/', 
    samples: { 'A0': 'A0.mp3', 'C1': 'C1.mp3', 'A1': 'A1.mp3', 'C2': 'C2.mp3', 'A2': 'A2.mp3', 'C3': 'C3.mp3', 'A3': 'A3.mp3', 'C4': 'C4.mp3', 'A4': 'A4.mp3', 'C5': 'C5.mp3', 'A5': 'A5.mp3', 'C6': 'C6.mp3', 'A6': 'A6.mp3', 'C7': 'C7.mp3', 'C8': 'C8.mp3' }
  },
  organ: { 
    name: 'Organ', 
    category: 'Keys', 
    region: 'Western',
    color: '#6366f1', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-organ-mp3@1.1.1/', 
    samples: { 'A2': 'A2.mp3', 'A3': 'A3.mp3', 'A4': 'A4.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'C5': 'C5.mp3' }
  },
  harmonium: { 
    name: 'Harmonium', 
    category: 'Keys', 
    region: 'India',
    color: '#f472b6', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-harmonium-mp3@1.1.1/', 
    samples: { 'A2': 'A2.mp3', 'A3': 'A3.mp3', 'A4': 'A4.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'C5': 'C5.mp3', 'E3': 'E3.mp3', 'E4': 'E4.mp3', 'G3': 'G3.mp3', 'G4': 'G4.mp3' }
  },
  
  // ============================================
  // STRINGS - WESTERN
  // ============================================
  cello: { 
    name: 'Cello', 
    category: 'Strings', 
    region: 'Western',
    color: '#8b5cf6', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-cello-mp3@1.1.1/', 
    samples: { 'A2': 'A2.mp3', 'A3': 'A3.mp3', 'A4': 'A4.mp3', 'C2': 'C2.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'C5': 'C5.mp3', 'E2': 'E2.mp3', 'E3': 'E3.mp3', 'E4': 'E4.mp3', 'G2': 'G2.mp3', 'G3': 'G3.mp3', 'G4': 'G4.mp3' }
  },
  violin: { 
    name: 'Violin', 
    category: 'Strings', 
    region: 'Western',
    color: '#a855f7', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-violin-mp3@1.1.1/', 
    samples: { 'A3': 'A3.mp3', 'A4': 'A4.mp3', 'A5': 'A5.mp3', 'C4': 'C4.mp3', 'C5': 'C5.mp3', 'C6': 'C6.mp3', 'E4': 'E4.mp3', 'E5': 'E5.mp3', 'G4': 'G4.mp3', 'G5': 'G5.mp3' }
  },
  contrabass: { 
    name: 'Contrabass', 
    category: 'Strings', 
    region: 'Western',
    color: '#7c3aed', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-contrabass-mp3@1.1.2/', 
    samples: { 'A2': 'A2.mp3', 'C2': 'C2.mp3', 'E2': 'E2.mp3', 'G1': 'G1.mp3', 'D2': 'D2.mp3' }
  },
  harp: { 
    name: 'Harp', 
    category: 'Strings', 
    region: 'Western',
    color: '#c084fc', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-harp-mp3@1.1.1/', 
    samples: { 'A2': 'A2.mp3', 'A4': 'A4.mp3', 'C3': 'C3.mp3', 'C5': 'C5.mp3', 'E3': 'E3.mp3', 'E5': 'E5.mp3', 'G3': 'G3.mp3', 'G5': 'G5.mp3' }
  },
  
  // ============================================
  // GUITARS & PLUCKED
  // ============================================
  'guitar-acoustic': { 
    name: 'Acoustic Guitar', 
    category: 'Guitar', 
    region: 'Western',
    color: '#ea580c', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-guitar-acoustic-mp3@1.1.2/', 
    samples: { 'A2': 'A2.mp3', 'A3': 'A3.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'E2': 'E2.mp3', 'E3': 'E3.mp3', 'E4': 'E4.mp3', 'G2': 'G2.mp3', 'G3': 'G3.mp3' }
  },
  'guitar-electric': { 
    name: 'Electric Guitar', 
    category: 'Guitar', 
    region: 'Western',
    color: '#ef4444', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-guitar-electric-mp3@1.1.2/', 
    samples: { 'A2': 'A2.mp3', 'A3': 'A3.mp3', 'A4': 'A4.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'C5': 'C5.mp3', 'E2': 'E2.mp3', 'E3': 'E3.mp3', 'E4': 'E4.mp3' }
  },
  'guitar-nylon': { 
    name: 'Nylon Guitar', 
    category: 'Guitar', 
    region: 'Spain',
    color: '#f97316', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-guitar-nylon-mp3@1.1.2/', 
    samples: { 'A2': 'A2.mp3', 'A3': 'A3.mp3', 'A4': 'A4.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'E2': 'E2.mp3', 'E3': 'E3.mp3', 'E4': 'E4.mp3', 'G3': 'G3.mp3' }
  },
  
  // ============================================
  // BASS
  // ============================================
  'bass-electric': { 
    name: 'Electric Bass', 
    category: 'Bass', 
    region: 'Western',
    color: '#dc2626', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-bass-electric-mp3@1.1.2/', 
    samples: { 'A1': 'A1.mp3', 'A2': 'A2.mp3', 'C2': 'C2.mp3', 'C3': 'C3.mp3', 'E1': 'E1.mp3', 'E2': 'E2.mp3', 'G1': 'G1.mp3', 'G2': 'G2.mp3' }
  },
  
  // ============================================
  // BRASS
  // ============================================
  trumpet: { 
    name: 'Trumpet', 
    category: 'Brass', 
    region: 'Western',
    color: '#f59e0b', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-trumpet-mp3@1.1.2/', 
    samples: { 'A3': 'A3.mp3', 'A5': 'A5.mp3', 'C4': 'C4.mp3', 'C6': 'C6.mp3', 'E4': 'E4.mp3', 'G4': 'G4.mp3' }
  },
  trombone: { 
    name: 'Trombone', 
    category: 'Brass', 
    region: 'Western',
    color: '#fbbf24', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-trombone-mp3@1.1.2/', 
    samples: { 'A#2': 'As2.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'F2': 'F2.mp3', 'F3': 'F3.mp3', 'A#3': 'As3.mp3' }
  },
  tuba: { 
    name: 'Tuba', 
    category: 'Brass', 
    region: 'Western',
    color: '#d97706', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-tuba-mp3@1.1.2/', 
    samples: { 'A#1': 'As1.mp3', 'A#2': 'As2.mp3', 'D2': 'D2.mp3', 'D3': 'D3.mp3', 'F1': 'F1.mp3', 'F2': 'F2.mp3' }
  },
  'french-horn': { 
    name: 'French Horn', 
    category: 'Brass', 
    region: 'Western',
    color: '#b45309', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-french-horn-mp3@1.1.2/', 
    samples: { 'A1': 'A1.mp3', 'A3': 'A3.mp3', 'C2': 'C2.mp3', 'C4': 'C4.mp3', 'D3': 'D3.mp3', 'F3': 'F3.mp3' }
  },
  
  // ============================================
  // WOODWINDS
  // ============================================
  flute: { 
    name: 'Flute', 
    category: 'Woodwinds', 
    region: 'Western',
    color: '#10b981', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-flute-mp3@1.1.2/', 
    samples: { 'A4': 'A4.mp3', 'A5': 'A5.mp3', 'C4': 'C4.mp3', 'C5': 'C5.mp3', 'C6': 'C6.mp3', 'E4': 'E4.mp3', 'E5': 'E5.mp3' }
  },
  saxophone: { 
    name: 'Saxophone', 
    category: 'Woodwinds', 
    region: 'Western',
    color: '#14b8a6', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-saxophone-mp3@1.1.2/', 
    samples: { 'A3': 'A3.mp3', 'A4': 'A4.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'E3': 'E3.mp3', 'E4': 'E4.mp3', 'G3': 'G3.mp3', 'G4': 'G4.mp3' }
  },
  bassoon: { 
    name: 'Bassoon', 
    category: 'Woodwinds', 
    region: 'Western',
    color: '#059669', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-bassoon-mp3@1.1.2/', 
    samples: { 'A2': 'A2.mp3', 'A3': 'A3.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'E3': 'E3.mp3', 'G2': 'G2.mp3', 'G3': 'G3.mp3' }
  },
  clarinet: { 
    name: 'Clarinet', 
    category: 'Woodwinds', 
    region: 'Western',
    color: '#047857', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-clarinet-mp3@1.1.2/', 
    samples: { 'A3': 'A3.mp3', 'A4': 'A4.mp3', 'A5': 'A5.mp3', 'C4': 'C4.mp3', 'C5': 'C5.mp3', 'E4': 'E4.mp3', 'G4': 'G4.mp3' }
  },
  
  // ============================================
  // MALLETS & PERCUSSION
  // ============================================
  xylophone: { 
    name: 'Xylophone', 
    category: 'Mallets', 
    region: 'Western',
    color: '#ec4899', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-xylophone-mp3@1.1.1/', 
    samples: { 'C4': 'C4.mp3', 'C5': 'C5.mp3', 'C6': 'C6.mp3', 'G4': 'G4.mp3', 'G5': 'G5.mp3', 'G6': 'G6.mp3' }
  },
  
  // ============================================
  // WORLD - AFRICA
  // ============================================
  kalimba: { 
    name: 'Kalimba (Thumb Piano)', 
    category: 'World - Africa', 
    region: 'Africa',
    color: '#84cc16', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-kalimba-mp3@1.0.0/', 
    samples: { 'C4': 'C4.mp3', 'D4': 'D4.mp3', 'E4': 'E4.mp3', 'G4': 'G4.mp3', 'A4': 'A4.mp3', 'C5': 'C5.mp3', 'D5': 'D5.mp3', 'E5': 'E5.mp3' }
  },
  
  // Djembe - African hand drum (using membrane synth with custom settings)
  djembe: {
    name: 'Djembe',
    category: 'World - Africa',
    region: 'Africa',
    color: '#65a30d',
    isSynth: true,
    synthType: 'MembraneSynth',
    synthOptions: { pitchDecay: 0.05, octaves: 6, envelope: { attack: 0.001, decay: 0.4, sustain: 0.01, release: 1.4 } }
  },
  
  // Talking Drum - West African
  'talking-drum': {
    name: 'Talking Drum',
    category: 'World - Africa',
    region: 'Africa',
    color: '#4d7c0f',
    isSynth: true,
    synthType: 'MembraneSynth',
    synthOptions: { pitchDecay: 0.3, octaves: 4, envelope: { attack: 0.01, decay: 0.8, sustain: 0.1, release: 1 } }
  },
  
  // ============================================
  // WORLD - ASIA (Japan, China, Korea)
  // ============================================
  koto: { 
    name: 'Koto', 
    category: 'World - Asia', 
    region: 'Japan',
    color: '#f43f5e', 
    cdnBase: 'https://cdn.jsdelivr.net/npm/tonejs-instrument-koto-mp3@1.0.0/', 
    samples: { 'A3': 'A3.mp3', 'A4': 'A4.mp3', 'C3': 'C3.mp3', 'C4': 'C4.mp3', 'C5': 'C5.mp3', 'E3': 'E3.mp3', 'E4': 'E4.mp3', 'G3': 'G3.mp3', 'G4': 'G4.mp3' }
  },
  
  // Erhu - Chinese bowed string (using FM synth to emulate)
  erhu: {
    name: 'Erhu',
    category: 'World - Asia',
    region: 'China',
    color: '#ef4444',
    isSynth: true,
    synthType: 'FMSynth',
    synthOptions: { modulationIndex: 3, harmonicity: 2.5, envelope: { attack: 0.1, decay: 0.2, sustain: 0.8, release: 0.5 } }
  },
  
  // Guzheng - Chinese zither (using pluck synth)
  guzheng: {
    name: 'Guzheng',
    category: 'World - Asia',
    region: 'China',
    color: '#dc2626',
    isSynth: true,
    synthType: 'PluckSynth',
    synthOptions: { attackNoise: 1, dampening: 4000, resonance: 0.95 }
  },
  
  // Shamisen - Japanese 3-string (using pluck)
  shamisen: {
    name: 'Shamisen',
    category: 'World - Asia',
    region: 'Japan',
    color: '#e11d48',
    isSynth: true,
    synthType: 'PluckSynth',
    synthOptions: { attackNoise: 2, dampening: 3000, resonance: 0.9 }
  },
  
  // Taiko - Japanese drums
  taiko: {
    name: 'Taiko Drum',
    category: 'World - Asia',
    region: 'Japan',
    color: '#be123c',
    isSynth: true,
    synthType: 'MembraneSynth',
    synthOptions: { pitchDecay: 0.1, octaves: 8, envelope: { attack: 0.001, decay: 0.5, sustain: 0.1, release: 2 } }
  },
  
  // ============================================
  // WORLD - MIDDLE EAST
  // ============================================
  oud: {
    name: 'Oud',
    category: 'World - Middle East',
    region: 'Middle East',
    color: '#f59e0b',
    isSynth: true,
    synthType: 'PluckSynth',
    synthOptions: { attackNoise: 1.5, dampening: 2500, resonance: 0.92 }
  },
  
  sitar: {
    name: 'Sitar',
    category: 'World - Middle East',
    region: 'India',
    color: '#d97706',
    isSynth: true,
    synthType: 'PluckSynth',
    synthOptions: { attackNoise: 2, dampening: 2000, resonance: 0.98 }
  },
  
  tabla: {
    name: 'Tabla',
    category: 'World - Middle East',
    region: 'India',
    color: '#b45309',
    isSynth: true,
    synthType: 'MembraneSynth',
    synthOptions: { pitchDecay: 0.15, octaves: 5, envelope: { attack: 0.001, decay: 0.3, sustain: 0.05, release: 0.8 } }
  },
  
  darbuka: {
    name: 'Darbuka (Doumbek)',
    category: 'World - Middle East',
    region: 'Middle East',
    color: '#92400e',
    isSynth: true,
    synthType: 'MembraneSynth',
    synthOptions: { pitchDecay: 0.08, octaves: 6, envelope: { attack: 0.001, decay: 0.25, sustain: 0.02, release: 0.6 } }
  },
  
  // ============================================
  // WORLD - INDONESIA
  // ============================================
  gamelan: {
    name: 'Gamelan',
    category: 'World - Indonesia',
    region: 'Indonesia',
    color: '#22c55e',
    isSynth: true,
    synthType: 'MetalSynth',
    synthOptions: { frequency: 200, envelope: { attack: 0.001, decay: 1, release: 1 }, harmonicity: 5.1, modulationIndex: 32, resonance: 4000, octaves: 1.5 }
  },
  
  angklung: {
    name: 'Angklung',
    category: 'World - Indonesia',
    region: 'Indonesia',
    color: '#16a34a',
    isSynth: true,
    synthType: 'PluckSynth',
    synthOptions: { attackNoise: 0.5, dampening: 5000, resonance: 0.85 }
  },
  
  // ============================================
  // WORLD - LATIN AMERICA / CARIBBEAN
  // ============================================
  steelpan: {
    name: 'Steel Pan (Caribbean)',
    category: 'World - Latin',
    region: 'Latin America',
    color: '#eab308',
    isSynth: true,
    synthType: 'MetalSynth',
    synthOptions: { frequency: 200, envelope: { attack: 0.001, decay: 0.4, release: 0.2 }, harmonicity: 3.1, modulationIndex: 16, resonance: 5000, octaves: 1 }
  },
  
  berimbau: {
    name: 'Berimbau (Brasil)',
    category: 'World - Latin',
    region: 'Latin America',
    color: '#ca8a04',
    isSynth: true,
    synthType: 'PluckSynth',
    synthOptions: { attackNoise: 1, dampening: 1500, resonance: 0.97 }
  },
  
  congas: {
    name: 'Congas',
    category: 'World - Latin',
    region: 'Latin America',
    color: '#a16207',
    isSynth: true,
    synthType: 'MembraneSynth',
    synthOptions: { pitchDecay: 0.05, octaves: 5, envelope: { attack: 0.001, decay: 0.35, sustain: 0.05, release: 0.7 } }
  },
  
  bongos: {
    name: 'Bongos',
    category: 'World - Latin',
    region: 'Latin America',
    color: '#854d0e',
    isSynth: true,
    synthType: 'MembraneSynth',
    synthOptions: { pitchDecay: 0.03, octaves: 4, envelope: { attack: 0.001, decay: 0.2, sustain: 0.02, release: 0.4 } }
  },
  
  maracas: {
    name: 'Maracas',
    category: 'World - Latin',
    region: 'Latin America',
    color: '#713f12',
    isSynth: true,
    synthType: 'NoiseSynth',
    synthOptions: { noise: { type: 'white' }, envelope: { attack: 0.005, decay: 0.1, sustain: 0 } }
  },
  
  // ============================================
  // SYNTHS (Built-in Tone.js - no samples needed)
  // ============================================
  synth: { 
    name: 'Classic Synth', 
    category: 'Synths', 
    region: 'Electronic',
    color: '#06b6d4', 
    isSynth: true,
    synthType: 'Synth'
  },
  'fm-synth': { 
    name: 'FM Synth', 
    category: 'Synths', 
    region: 'Electronic',
    color: '#0891b2', 
    isSynth: true,
    synthType: 'FMSynth'
  },
  'am-synth': { 
    name: 'AM Synth', 
    category: 'Synths', 
    region: 'Electronic',
    color: '#0e7490', 
    isSynth: true,
    synthType: 'AMSynth'
  },
  'duo-synth': { 
    name: 'Duo Synth', 
    category: 'Synths', 
    region: 'Electronic',
    color: '#155e75', 
    isSynth: true,
    synthType: 'DuoSynth'
  },
  'mono-synth': { 
    name: 'Mono Synth', 
    category: 'Synths', 
    region: 'Electronic',
    color: '#164e63', 
    isSynth: true,
    synthType: 'MonoSynth'
  },
  'pluck-synth': { 
    name: 'Pluck Synth', 
    category: 'Synths', 
    region: 'Electronic',
    color: '#22d3ee', 
    isSynth: true,
    synthType: 'PluckSynth'
  },
  'membrane-synth': { 
    name: 'Membrane (Kick/Tom)', 
    category: 'Synths', 
    region: 'Electronic',
    color: '#67e8f9', 
    isSynth: true,
    synthType: 'MembraneSynth'
  },
  'metal-synth': { 
    name: 'Metal Synth (Hi-Hats)', 
    category: 'Synths', 
    region: 'Electronic',
    color: '#a5f3fc', 
    isSynth: true,
    synthType: 'MetalSynth'
  },
  'noise-synth': { 
    name: 'Noise Synth (Percussion)', 
    category: 'Synths', 
    region: 'Electronic',
    color: '#cffafe', 
    isSynth: true,
    synthType: 'NoiseSynth'
  },
};

// Regional groupings for UI
export const REGIONS = {
  'Western': { flag: '🎼', color: '#3b82f6' },
  'Africa': { flag: '🌍', color: '#84cc16' },
  'Japan': { flag: '🇯🇵', color: '#f43f5e' },
  'China': { flag: '🇨🇳', color: '#ef4444' },
  'India': { flag: '🇮🇳', color: '#f472b6' },
  'Middle East': { flag: '🕌', color: '#f59e0b' },
  'Indonesia': { flag: '🇮🇩', color: '#22c55e' },
  'Latin America': { flag: '🌎', color: '#eab308' },
  'Spain': { flag: '🇪🇸', color: '#f97316' },
  'Electronic': { flag: '🎛️', color: '#06b6d4' },
};

// Build categories from INSTRUMENT_LIBRARY
export const CATEGORIES = {};
Object.entries(INSTRUMENT_LIBRARY).forEach(([id, inst]) => {
  if (!CATEGORIES[inst.category]) CATEGORIES[inst.category] = [];
  CATEGORIES[inst.category].push({ id, ...inst });
});

// Keyboard mapping for MIDI-style input (maps key code to note)
export const KEYBOARD_MAP = {
  // Bottom row - samples 0-6 (for drum pads)
  'KeyZ': 0, 'KeyX': 1, 'KeyC': 2, 'KeyV': 3, 'KeyB': 4, 'KeyN': 5, 'KeyM': 6,
  // Middle row - samples 7-15
  'KeyA': 7, 'KeyS': 8, 'KeyD': 9, 'KeyF': 10, 'KeyG': 11, 'KeyH': 12, 'KeyJ': 13, 'KeyK': 14, 'KeyL': 15,
  // Top row - samples 16-25
  'KeyQ': 16, 'KeyW': 17, 'KeyE': 18, 'KeyR': 19, 'KeyT': 20, 'KeyY': 21, 'KeyU': 22, 'KeyI': 23, 'KeyO': 24, 'KeyP': 25
};

// Piano keyboard mapping (computer keyboard to notes)
export const PIANO_KEYBOARD_MAP = {
  // White keys (bottom row)
  'KeyA': 'C3', 'KeyS': 'D3', 'KeyD': 'E3', 'KeyF': 'F3', 'KeyG': 'G3', 'KeyH': 'A3', 'KeyJ': 'B3',
  'KeyK': 'C4', 'KeyL': 'D4', 'Semicolon': 'E4',
  // Black keys (top row)
  'KeyW': 'C#3', 'KeyE': 'D#3', 'KeyT': 'F#3', 'KeyY': 'G#3', 'KeyU': 'A#3',
  'KeyO': 'C#4', 'KeyP': 'D#4',
  // Additional octave
  'KeyZ': 'C2', 'KeyX': 'D2', 'KeyC': 'E2', 'KeyV': 'F2', 'KeyB': 'G2', 'KeyN': 'A2', 'KeyM': 'B2',
};

// Quantize values
export const QUANTIZE_VALUES = [
  { label: '1/4 (Quarter)', value: 1, subdivision: 4 },
  { label: '1/8 (Eighth)', value: 0.5, subdivision: 8 },
  { label: '1/16 (Sixteenth)', value: 0.25, subdivision: 16 },
  { label: '1/32 (Thirty-second)', value: 0.125, subdivision: 32 },
  { label: 'Off (Free)', value: 0, subdivision: 0 },
];

// MIDI note number to note name mapping
export const MIDI_NOTE_TO_NAME = {};
for (let octave = -1; octave <= 9; octave++) {
  NOTE_NAMES.forEach((note, index) => {
    const midiNumber = (octave + 1) * 12 + index;
    if (midiNumber >= 0 && midiNumber <= 127) {
      MIDI_NOTE_TO_NAME[midiNumber] = `${note}${octave}`;
    }
  });
}
